// صفحة مهام انوار - التصميم والمنطق موحّدين بـ components/EmployeeTasksPage.jsx
import React from "react";
import EmployeeTasksPage from "./components/EmployeeTasksPage";

const AnwarTasks = () => (
  <EmployeeTasksPage employeeName="انوار" title="انوار" />
);

export default AnwarTasks;
